import React from "react";
import Questionnaire from "../homecomponents/Questionnaire";
import Slogan from "../mapcomponents/Slogan";
import { Link } from "react-router-dom";
import "./HomePage.css";
import FeatureCards from "../mapcomponents/FeatureCards";

function HomePage() {
  return (
    <div>
      <Slogan main={"Her Safety Guide, Her Guide to Safer Nights"} sub={""} />
      <FeatureCards />
      <div className="start">
        <Link to="/route" style={{ textDecoration: "none" }}>
          <button className="btn btn-ui">Light Your Way Home</button>
        </Link>
      </div>
    </div>
  );
}

export default HomePage;
